import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-solid-svg-icons';

import { getCurrentFile } from '../store/selectors';
import {
  downloadImportSummary,
  downloadOriginalFile,
  downloadSkippedRecords
} from '../store/actions/importer';

export function ImportActions({
  onDownloadImportSummary,
  onDownloadOriginalFile,
  onDownloadSkippedRecords
}) {
  const renderIcon = (icon) => {
    return (
      <FontAwesomeIcon className="mr-3" icon={icon} />
    );
  };

  return (
    <Dropdown className="import-actions">
      <Dropdown.Toggle>
        Actions
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <MenuItem key="import-summary" name="import-summary" onClick={onDownloadImportSummary}>
          {renderIcon(faDownload)} Download Import Summary
        </MenuItem>
        <MenuItem key="skipped" name="skipped" onClick={onDownloadSkippedRecords}>
          {renderIcon(faDownload)} Download Skipped Records
        </MenuItem>
        <MenuItem key="original" name="original" onClick={onDownloadOriginalFile}>
          {renderIcon(faDownload)} Download Original File
        </MenuItem>
      </Dropdown.Menu>
    </Dropdown>
  );
}

ImportActions.propTypes = {
  onDownloadImportSummary: PropTypes.func.isRequired,
  onDownloadOriginalFile: PropTypes.func.isRequired,
  onDownloadSkippedRecords: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  currentFile: getCurrentFile(state),
});

const mapDispatchToProps = {
  onDownloadImportSummary: downloadImportSummary,
  onDownloadOriginalFile: downloadOriginalFile,
  onDownloadSkippedRecords: downloadSkippedRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportActions);
